export default {
  AWARD_DEPLOY_MOUNT: 'award:deploy:mount',
  AWARD_DEPLOY_SHOW: 'award:deploy:show',
  ENTERPRISE_AWARD_BULK_DEPLOY_CLICK: 'enterprise-award-bulk-deploy:click',
  ENTERPRISE_AWARD_BULK_DEPLOY_OPEN: 'enterprise-award-bulk-deploy:open',
  ENTERPRISE_AWARD_BULK_DEPLOY_COMPLETE:
    'enterprise-award-bulk-deploy:complete',
  ENTERPRISE_AWARD_REPORT_CLICK: 'enterprise-award-report:click',
};
